export default "__VITE_ASSET__76a893ed__"